export default __webpack_public_path__ + "static/media/alexanderdrawing.2efca8c8.jpg";